import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, IconButton } from "@mui/material";
export const PIconButton = ({ children, color, border, size = "large", onClick, disabled, styles, buttonRef, }) => {
    return (_jsx(IconButton, { ref: buttonRef, style: {
            color: color,
            border: `1px solid ${alpha(color, 0.16)}`,
        }, sx: {
            "&:disabled": {
                opacity: 0.5,
            },
            ...styles,
        }, onClick: onClick, size: size, disabled: disabled, children: children }));
};
